import { render, staticRenderFns } from "./PlainTopNavLayout.vue?vue&type=template&id=2e438d59&"
import script from "./PlainTopNavLayout.vue?vue&type=script&lang=ts&"
export * from "./PlainTopNavLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports